import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVisaProfessionChnagesData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import ListVisaProfessionChanges from "./ListVisaProfession";

export default function VisProfessionChanges() {
  const visaData = useSelector((state) => state.visaProfessionChnages);
  const dispatch = useDispatch();

  //screen Title Show fun
  const titleBorder = [
    {
      label: "Visa Profession Changes",
      link: "/dashboard/VisProfessionChanges",
    },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const [trigger, setTrigger] = useState(false);

  // useEffect(() => {
  //   dispatch(getVisaProfessionChnagesData(token));
  // }, [trigger]);

  const callApi = () => {
    dispatch(getVisaProfessionChnagesData(token));
    console.log("print.....");
  };

  console.log("vis aprofession change page in my browser");
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <ListVisaProfessionChanges
          list={visaData}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE Name",
            "Client",
            "Visa Provider",
            "IQAMA Number",
            "PassPort Number",
            "IQAMA Profession",
            // "Current Profession",
            "Current Profession level",
            "Application Date",
            "New Visa Profession",
            "New Visa Profession Level",
            // "New Visa Provider",
            "",
          ]}
          token={token}
          updateData={callApi}
        />
      </div>
    </>
  );
}
